import { render, staticRenderFns } from "./FormAcessorio.vue?vue&type=template&id=8ccdeab6"
import script from "./FormAcessorio.vue?vue&type=script&lang=js"
export * from "./FormAcessorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports